import * as BaseSizes from './Size';

export enum Size {
  Small = BaseSizes.X3Large,
  Medium = 120,
}
